import { useMutation } from "react-query";
import api from "../api";

export const useCalculateTaxesMutation = () =>
  useMutation((data) =>
    api.put(`/tax/calculate`, data).then((res) => res.data)
  );
